import { useNavigate} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { t } from '../../i18n';
import { RootState } from "../../app/store";
import { setRequestOffer } from '../../features/homeSlice'
import { setHelpTab } from '../../features/homeSlice'
import {
  FooterContainer,
  LinksContainer,
  CopyrightContainer,
  TextWrapper,
  LinksWrapper,
  LinkCategory,
  LogoSocialLinksContainer
 } from './styles';
 import {
   DailaiLogo,
   FooterIcon,
   FooterLink,
   LeftColumnFlexNPChildren,
   RightColumnFlexNPChildren
 } from '../../globalStyles';
 import { SuspenseImg } from "../../SuspenseImage";

function Footer(){
    const { language } = useSelector((state: RootState) => state.language)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const gotoPostList = (e: any) => {
        e.preventDefault()
        dispatch(setRequestOffer(''))
        navigate('/services/list')
    }

    const gotoHelpCenter = (e: any) => {
        e.preventDefault()
        dispatch(setHelpTab('SECURITY'))
        navigate('/help')
    }

    const gotoGettingStarted = (e: any) => {
        e.preventDefault()
        dispatch(setHelpTab('GETTING STARTED'))
        navigate('/help')
    }
    // const gotoPostListRequest = (e: any) => {
    //     e.preventDefault()
    //     dispatch(setRequestOffer('REQUEST'))
    //     navigate('/services/list')
    // }
    // const gotoPostListOffer = (e: any) => {
    //     e.preventDefault()
    //     dispatch(setRequestOffer('OFFER'))
    //     navigate('/services/list')
    // }
    const gotoTerms = (e: any) => {
        e.preventDefault()
        navigate('/terms')
    }
    const gotoPolicy = (e: any) => {
        e.preventDefault()
        navigate('/policy')
    }
    const gotoDisclaimer = (e: any) => {
        e.preventDefault()
        navigate('/disclaimer')
    }

    return <>
      <FooterContainer>
        <LinksContainer>

            <LogoSocialLinksContainer>
              <TextWrapper>
                  <DailaiLogo
                    src="https://res.cloudinary.com/dba8ifej6/image/upload/v1644370206/dailai_footer_logo_cqe1t3.png"
                    onClick={() => navigate('/')}
                    style={{cursor: 'pointer'}}
                    alt="Dailai logo"
                  />
                  <div>
                    <p>Follow us</p>
                    <div>
                      <a href="https://www.facebook.com/Dailai-110030758350752" target="blank">
                        <SuspenseImg src="https://res.cloudinary.com/dba8ifej6/image/upload/v1649914878/social_facebook_oeejve.png" alt="Facebook icon" className="footerIcon"/>
                      </a>
                      <a href="https://www.twitter.com/DailaiIo" target="blank">
                        <SuspenseImg src="https://res.cloudinary.com/dba8ifej6/image/upload/v1649914878/social_twitter_zclbny.png" alt="Twitter icon" className="footerIcon" />
                      </a>
                      <a href="https://www.youtube.com/channel/UCKgSzgr1dKW1ktvticHCNBw" target="blank">
                        <SuspenseImg src="https://res.cloudinary.com/dba8ifej6/image/upload/v1649914878/social_youtube_itodff.png" alt="Youtube icon" className="footerIcon" />
                      </a>
                      <a href="https://www.instagram.com/dailai.io/" target="blank">
                        <SuspenseImg src="https://res.cloudinary.com/dba8ifej6/image/upload/v1649914879/social_instagram_q482ph.png" alt="Instagram icon" className="footerIcon" />
                      </a>
                      <a href="https://www.tiktok.com/@dailai.io" target="blank">
                        <SuspenseImg src="https://res.cloudinary.com/dba8ifej6/image/upload/v1649914879/social_tiktok_yfz9xs.png" alt="Tiktok icon" className="footerIcon" />
                      </a>
                      <a href="https://www.linkedin.com/company/dailai" target="blank">
                        <SuspenseImg src="https://res.cloudinary.com/dba8ifej6/image/upload/v1649914878/social_linkedin_oiwmt7.png" alt="LinkedIn icon" className="footerIcon" />
                      </a>
                    </div>
                  </div>
              </TextWrapper>
            </LogoSocialLinksContainer>
            <RightColumnFlexNPChildren>
              <LinksWrapper>
                <LeftColumnFlexNPChildren>
                  <LinkCategory>{t("General", language)}</LinkCategory>
                  <FooterLink onClick={() => navigate("/about")}>{t("About Us", language)}</FooterLink>
                  <FooterLink onClick={() => navigate("/faqs")}>{t("FAQs", language)}</FooterLink>
                  <FooterLink onClick={gotoHelpCenter}>{t("Help Center", language)}</FooterLink>
                </LeftColumnFlexNPChildren>
                <RightColumnFlexNPChildren>
                  <LinkCategory>{t("Directories", language)}</LinkCategory>
                  <FooterLink onClick={gotoPostList}>{t("Posts", language)}</FooterLink>
                  <FooterLink onClick={() => navigate("/blog/list")}>{t("Blogs", language)}</FooterLink>
                  <FooterLink onClick={gotoGettingStarted}>{t("Getting Started", language)}</FooterLink>
                </RightColumnFlexNPChildren>
                <RightColumnFlexNPChildren>
                  <LinkCategory>{t("Security", language)}</LinkCategory>
                  <FooterLink onClick={gotoTerms}>{t("Terms of Use", language)}</FooterLink>
                  <FooterLink onClick={gotoPolicy}>{t("Privacy Policy", language)}</FooterLink>
                  <FooterLink onClick={gotoDisclaimer}>{t("Disclaimer", language)}</FooterLink>
                </RightColumnFlexNPChildren>
              </LinksWrapper>
            </RightColumnFlexNPChildren>

        </LinksContainer>
        <CopyrightContainer>
          <p>&copy; 2022 Dailai, All rights reserved</p>
        </CopyrightContainer>
      </FooterContainer>
    </>
}

export default Footer;
